import { render, staticRenderFns } from "./StudentEmail.vue?vue&type=template&id=0c0885da&"
import script from "./StudentEmail.vue?vue&type=script&lang=js&"
export * from "./StudentEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports